"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
;
var COLL_TYPES = {
    // 所有上报的类型定义
    jserror: 'jserror',
    api: 'api',
    per: 'per',
    log: 'log',
    jsonp: 'jsonp' // jsonp
};
// 对接棱镜的sub Source
exports.CONST_SUB_SOURCE = {
    // 所有上报的类型定义
    // js错误 仓运配日志采集-错误 http://prism.cainiao-inc.com/access/dsDetail.htm?dsId=3725
    jserror: '6114e',
    // api 仓运配日志采集 http://prism.cainiao-inc.com/access/dsDetail.htm?dsId=3719
    api: '7f74a',
    // 浏览器性能  苍云配日志采集_性能日志 http://prism.cainiao-inc.com/access/dsDetail.htm?dsId=3722
    per: '6099f',
    log: '1805a',
    jsonp: '' // jsonp
};
// 对接棱镜的sub Source
exports.CONST_PROVIDER_ID = {
    // 所有上报的类型定义
    // js错误 仓运配日志采集-错误 http://prism.cainiao-inc.com/access/dsDetail.htm?dsId=3725
    jserror: 'wms_link_iot_report_error',
    // api 仓运配日志采集 http://prism.cainiao-inc.com/access/dsDetail.htm?dsId=3719
    api: 'wms_link_iot_report_api',
    // 浏览器性能  苍云配日志采集_性能日志 http://prism.cainiao-inc.com/access/dsDetail.htm?dsId=3722
    per: 'wms_link_iot_report_per',
    log: 'wms_link_iot_report_cus',
    jsonp: '' // jsonp
};
// 获得 仓 | 运 | 配 | 快递 的类型  'ware' | 'trans' | 'dist' | 'deli'
function getCollType(type) {
    var map = __assign({}, COLL_TYPES);
    for (var k in map) {
        map[k] = type;
    }
    return map;
}
exports.getCollType = getCollType;
exports.CONST_COLL_TYPE = ['ware', 'trans', 'dist', 'deli'];
exports.CONST_AREA_URL = {
    cn: '//shidclink.cainiao.com/gateway/link.do',
    sg: '//aplink.cloud.cainiao.com/gateway/link.do',
    ru: '//shidclink.cainiao.com/gateway/link.do' // //rulink.cainiao.com/gateway/link.do
};
//# sourceMappingURL=coll.type.js.map